import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { CouponService } from 'app/services/campaign/coupon.service';
import { moment } from 'fullcalendar';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-coupon-manager',
  templateUrl: './coupon-manager.component.html',
  styleUrls: ['./coupon-manager.component.css']
})
export class CouponManagerComponent implements OnInit {

  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;
  @ViewChild('table') table: KontableComponent;
  @Input() customerId: any;
  @Input() couponTab: string;

  couponList: any;

  operationCoupon: {
    couponCode?: string,
    barcode: string,
    operation: string,
    cardId?: number,
    cardNo?: string,
    customerId?: number,
    touchpointCode?: string
  }

  constructor(
    public campaignService: Campaign2Service,
    private couponService: CouponService,
    private messageService: MessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    campaignService.customerId = activatedRoute.snapshot.params['customerId'];
    campaignService.clientCustomerId = activatedRoute.snapshot.params['customer_id'];
  }

  ngOnInit() {
    this.getCouponList();
  }

  getCouponList() {
    this.campaignService.getCouponByCustomerId(this.customerId).subscribe(res => {
      this.couponList = []
      res.data.forEach(coupon => {
        //if(coupon.fruition_date_start && coupon.fruition_date_end) {
        //  coupon.isUsable = coupon.fruition_date_start <= moment().format('YYYY-MM-DD') && moment().format('YYYY-MM-DD') <= coupon.fruition_date_end;
        //} else coupon.isUsable = false;
        this.couponList.push(coupon);
      });
    })
  }

  viewCouponHistory(coupon) {
    this.router.navigate([`coupon-history/${this.campaignService.customerId}/${this.campaignService.clientCustomerId}/${coupon.id}`, {previousTab: this.couponTab}])
  }

  printCoupon(event: any, operation: string) {
    this.operationCoupon = {
      couponCode: event.coupon_code,
      barcode: event.barcode,
      operation: operation,
      cardNo: event.card_no,
      touchpointCode: "KONCENTRO.GUI",

    }
    this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
      this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });
  }

  reserveCoupon(event) {
    this.operationCoupon = {
      couponCode: event.coupon_code,
      barcode: event.barcode,
      operation: "R",
      cardNo: event.card_no,
      touchpointCode: "KONCENTRO.GUI",
    }
    this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
      this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });
  }

  useCoupon(event) {
    this.operationCoupon = {
      couponCode: event.coupon_code,
      barcode: event.barcode,
      operation: "U",
      cardNo: event.card_no,
      touchpointCode: "KONCENTRO.GUI",
    }
    this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
      this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });
  }

  undoReserveCoupon(event) {
    this.operationCoupon = {
      couponCode: event.coupon_code,
      barcode: event.barcode,
      operation: "UR",
      cardNo: event.card_no,
      touchpointCode: "KONCENTRO.GUI",
    }
    this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
      this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });
  }

  undoUseCoupon(event) {
    this.operationCoupon = {
      couponCode: event.coupon_code,
      barcode: event.barcode,
      operation: "UU",
      cardNo: event.card_no,
      touchpointCode: "KONCENTRO.GUI",
    }
    this.couponService.updateCoupon(this.operationCoupon).subscribe(res => {
      this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/coupon-manager/coupon-manager.component.ts